/**
 * useRecaptchaAction — reusable hook that obtains a Google reCAPTCHA v3
 * token for a specific action. Returns null if reCAPTCHA hasn't loaded
 * yet (e.g. network blocked) — callers should treat that as a soft skip
 * and let the backend bypass-token logic kick in for tests / dev.
 */
import { useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export function useRecaptchaAction() {
    const { executeRecaptcha } = useGoogleReCaptcha();

    const getToken = useCallback(async (action) => {
        if (!executeRecaptcha) {
            // eslint-disable-next-line no-console
            console.warn("[recaptcha] not yet loaded — submitting without token");
            return null;
        }
        try {
            return await executeRecaptcha(action);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn("[recaptcha] execute failed:", err?.message || err);
            return null;
        }
    }, [executeRecaptcha]);

    return { getToken, ready: !!executeRecaptcha };
}
